import { render, staticRenderFns } from "./CertificateIconActive.vue?vue&type=template&id=43962449"
import script from "./CertificateIconActive.vue?vue&type=script&lang=js"
export * from "./CertificateIconActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports